import I2302209250000001 from '@/assets/logosCamera/2-30220925000000-1.png';
import I23022092500000011 from '@/assets/logosCamera/2-30220925000000-11.png';
import I23022092500000013 from '@/assets/logosCamera/2-30220925000000-13.png';
import I23022092500000014 from '@/assets/logosCamera/2-30220925000000-14.png';
import I23022092500000015 from '@/assets/logosCamera/2-30220925000000-15.png';
import I23022092500000016 from '@/assets/logosCamera/2-30220925000000-16.png';
import I23022092500000017 from '@/assets/logosCamera/2-30220925000000-17.png';
import I23022092500000018 from '@/assets/logosCamera/2-30220925000000-18.png';
import I23022092500000019 from '@/assets/logosCamera/2-30220925000000-19.png';
import I2302209250000002 from '@/assets/logosCamera/2-30220925000000-2.png';
import I23022092500000020 from '@/assets/logosCamera/2-30220925000000-20.png';
import I23022092500000021 from '@/assets/logosCamera/2-30220925000000-21.png';
import I23022092500000022 from '@/assets/logosCamera/2-30220925000000-22.png';
import I23022092500000023 from '@/assets/logosCamera/2-30220925000000-23.png';
import I23022092500000024 from '@/assets/logosCamera/2-30220925000000-24.png';
import I23022092500000027 from '@/assets/logosCamera/2-30220925000000-27.png';
import I2302209250000003 from '@/assets/logosCamera/2-30220925000000-3.png';
import I2302209250000005 from '@/assets/logosCamera/2-30220925000000-5.png';
import I2302209250000006 from '@/assets/logosCamera/2-30220925000000-6.png';
import I2302209250000008 from '@/assets/logosCamera/2-30220925000000-8.png';
import I2302209250000009 from '@/assets/logosCamera/2-30220925000000-9.png';

const logos = {
  I2302209250000001,
  I23022092500000011,
  I23022092500000013,
  I23022092500000014,
  I23022092500000015,
  I23022092500000016,
  I23022092500000017,
  I23022092500000018,
  I23022092500000019,
  I2302209250000002,
  I23022092500000020,
  I23022092500000021,
  I23022092500000022,
  I23022092500000023,
  I23022092500000024,
  I23022092500000027,
  I2302209250000003,
  I2302209250000005,
  I2302209250000006,
  I2302209250000008,
  I2302209250000009,
};

export const getCameraLogo = (fileName: string) => {
  const logoCode = `I${fileName
    .split('.')[0]
    .replaceAll('-', '')}` as keyof typeof logos;

  return logos[logoCode];
};
